import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import addNoDataModule from 'highcharts/modules/no-data-to-display';
import HCMore from "highcharts/highcharts-more";

addNoDataModule(Highcharts);
HCMore(Highcharts);

export default class ExperienceChart extends Component {
  static propTypes = {
    yearsExperienceReport: PropTypes.arrayOf(
      PropTypes.shape({
        actual: PropTypes.number,
        target: PropTypes.number,
        yearsExperience: PropTypes.number,
        experience: PropTypes.number
      })
    ),
    isMP: PropTypes.bool
  };

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.yearsExperienceReport !== nextProps.yearsExperienceReport;
  }

  render() {
    let config = null; // eslint-disable-line prefer-const

    let categories = []; // eslint-disable-line prefer-const
    let positiveSeries = []; // eslint-disable-line prefer-const
    let negativeSeries = []; // eslint-disable-line prefer-const
    if (this.props.yearsExperienceReport) {
      const reportResult = this.props.yearsExperienceReport;

      for (let resultIdx = 0; resultIdx < reportResult.length; resultIdx++) {
        const result = reportResult[resultIdx];
        const high = result.actual * 1.2;
        const actual = result.actual;
        const low = result.actual - result.actual * 0.2;
        const years = result.experience ? result.experience : result.yearsExperience;
        categories.push(years);
        positiveSeries.push({
          high: high,
          low: actual,
          name: years,
          tooltip:
            '<span>+20%</span>: <b>$' +
            Math.round(high / 1000) +
            'K</span><br/>' +
            '<span>50th</span>: <b>$' +
            Math.round(actual / 1000) +
            'K</span><br/>' +
            '<span>-20%</span>: <b>$' +
            Math.round(low / 1000) +
            'K</span><br/>'
        });
        negativeSeries.push({
          high: actual,
          low: low,
          name: years,
          tooltip:
            '<span>+20%</span>: <b>$' +
            Math.round(high / 1000) +
            'K</span><br/>' +
            '<span>50th</span>: <b>$' +
            Math.round(actual / 1000) +
            'K</span><br/>' +
            '<span>-20%</span>: <b>$' +
            Math.round(low / 1000) +
            'K</span><br/>'
        });
      }

      config = {
        chart: {
          zoomType: 'xy',
          reflow: true,
          inverted: false,
          // renderTo: 'highcharts-canvas',
          height: 200,
          width: this.props.isMP ? 425 : 403
        },
        title: {
          text: 'Years Experience by Annualized Ranges (50th Percentile)',
          style: { color: '#333333', fontSize: '13px' },
          align: this.props.isMP ? 'left' : 'center'
        },
        subtitle: {
          text: ''
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            turboThreshold: 10000
          },
          bar: {
            stacking: 'normal'
          },
          area: {
            stacking: 'normal'
          },
          column: {
            stacking: 'normal'
          },
          columnrange: {
            grouping: false
          }
        },
        loading: {
          labelStyle: {
            top: '45%'
          }
        },
        legend: {
          enabled: false,
          align: 'center',
          itemMarginTop: 5,
          itemMarginBottom: 5,
          maxHeight: 80,
          layout: 'horizontal',
          verticalAlign: 'bottom',
          navigation: {
            activeColor: '#3E576F',
            animation: true,
            arrowSize: 12,
            inactiveColor: '#CCC',
            style: {
              fontWeight: 'bold',
              color: '#333',
              fontSize: '12px'
            }
          }
        },
        xAxis: {
          title: {
            text: ''
          },
          labels: {
            autoRotation: [
              -10,
              -20,
              -30,
              -40,
              -50,
              -60,
              -70,
              -80,
              -90,
              -100,
              -110,
              -120,
              -130,
              -140,
              -150,
              -160,
              -170,
              -180
            ],
            style: {
              fontSize: '12px',
              fontFamily: 'Verdana,  sans-serif'
            }
          },
          min: null,
          max: null,
          tickInterval: null,
          categories: categories
        },
        yAxis: {
          title: {
            text: ''
          },
          reversedStacks: false,
          type: 'linear',
          min: null,
          max: null,
          tickInterval: null
        },
        series: [
          {
            name: '+20%',
            xAxis: 0,
            yAxis: 0,
            index: 0,
            zIndex: 0,
            dataLabels: {
              style: {
                color: 'black'
              }
            },
            color: '#90eaee',
            showInLegend: true,
            connectNulls: true,
            tooltip: {
              headerFormat: '<span>Years: <b>{point.key}</b></span><br/>',
              pointFormat: '{point.tooltip}'
            },
            marker: {
              fillColor: '#90eaee', // rgba(240, 173, 78, 0.40)
              lineColor: '#90eaee', // rgba(240, 173, 78, 0.40)
              lineWidth: 0
            },
            id: 'graphSingleSeries-1308-Number of Jobs2',
            data: positiveSeries,
            type: 'columnrange',
            xValue: 'rw_111_null_null',
            // yValue: rw_439_null_null,
            innerSize: '45%',
            dimensionSetIdx: 0
          },
          {
            name: '-20%',
            xAxis: 0,
            yAxis: 0,
            index: 0,
            zIndex: 0,
            dataLabels: {
              style: {
                color: 'black'
              }
            },
            color: '#22d6dd',
            showInLegend: true,
            connectNulls: true,
            tooltip: {
              headerFormat: '<span>Years: <b>{point.key}</b></span><br/>',
              pointFormat: '{point.tooltip}'
            },
            marker: {
              fillColor: '#22d6dd', // rgba(240, 173, 78, 0.40)
              lineColor: '#22d6dd', // rgba(240, 173, 78, 0.40)
              lineWidth: 0
            },
            id: 'graphSingleSeries-1308-Number of Jobs',
            data: negativeSeries,
            type: 'columnrange',
            xValue: 'rw_111_null_null',
            // yValue: rw_439_null_null,
            innerSize: '45%',
            dimensionSetIdx: 0
          }
        ]
      };
    }

    return (
      <div className="add-job__experience__chart">
        {config ? <HighchartsReact highcharts={Highcharts} options={config} allowChartUpdate={true} /> : <p className="RightPanel__item--details" />}
      </div>
    );
  }
}
